import React from 'react'
import { Grid, Typography } from '@mui/material'
import { dsColorNew } from '@palette'
import { NoDataFound, AppTableSkeleton } from '@components'
import useRatingHistorical from 'Pages/ReportsAlerts/Reports/@hooks/useRatingHistorical'
import RatingHistoryTable from './RatingTable'


export default function RatingHistoricalContent({ idReport }) {
	const { reportName, data, isLoading } = useRatingHistorical(idReport)

	return <Grid container spacing={2}>
		{!!isLoading && <Grid item xs={12}>
			<AppTableSkeleton rows={5} columns={6}/>
		</Grid>}

		{!isLoading && !data.length && <Grid item xs={12}>
			<NoDataFound/>
		</Grid>}

		{!isLoading && !!data.length && <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
			<Typography sx={{ fontSize: 13, color: dsColorNew.textMuted }}>
				{data.length} execution{data.length === 1 ? '' : 's'}
			</Typography>
		</Grid>}

		{!isLoading && !!data.length && <Grid item xs={12}>
			<RatingHistoryTable reportName={reportName} data={data}/>
		</Grid>}
	</Grid>
}